import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import './custom.scss';
import './index.scss';

import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import WeaveTrainerPage from './features/weaveTrainer/WeaveTrainerPage';
import SkillTrainerPage from './features/skillTrainer/SkillTrainerPage';
import InfoToast from './features/toast/InfoToast';
import EquipmentPage from './features/equipment/EquipmentPage';
import ScriptsPage from './features/scripts/ScriptsPage';
import StatsPage from './features/stats/StatsPage';
import MobsPage from './features/mobs/MobsPage';
import EquipmentTrainerPage from './features/equipmentTrainer/EquipmentTrainerPage';
import MapPage from './features/map/MapPage';
import StatsDetailPage from './features/stats/StatsDetailPage';
import StatsCalc from './features/statscalc/StatsCalc';

const router = createBrowserRouter([
  { path: '/', element: <Navigate to='/skills' replace /> },
  { path: '/skills', element: <SkillTrainerPage /> },
  { path: '/weaves', element: <WeaveTrainerPage /> },
  { path: '/eqtrainer', element: <EquipmentTrainerPage /> },
  { path: '/equipment', element: <EquipmentPage /> },
  { path: '/mobs', element: <MobsPage /> },
  { path: '/map', element: <MapPage /> },
  { path: '/stats', element: <StatsCalc /> },
  {
    path: '/oldstats',
    element: <StatsPage />,
    children: [
      { path: ':race/:profession/:homeland', element: <StatsDetailPage /> }
    ]
  }, { path: '/scripts', element: <ScriptsPage /> }
]);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
      <InfoToast />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
